<template>
  <div class="ma-4">
    <v-snackbar v-model="msg" top>
      {{ text }}
      <v-btn color="pink" text @click="msg = false"> Close</v-btn></v-snackbar
    >
    <ClientNav />
    <v-row dense>
      <v-col cols="12" lg="3" xl="2">
        <ClientSide />
      </v-col>

      <v-col cols="12" lg="9" xl="10">
        <v-card class="pa-2" outlined tile height="100%">
          <v-data-table
            :headers="headers"
            :items="fireDrills"
            sort-by="Date"
            sort-desc
            :loading="isLoading"
            loading-text="Loading Client's Fire Drills"
            :search="search"
            height="550"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Fire Drills</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  clearable
                  flat
                  solo-inverted
                  hide-details
                  prepend-inner-icon="search"
                  label="search"
                  class="desktop"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-btn class="primary" @click="printTable()">
                    <v-icon small>
                        print
                    </v-icon>
                    Print
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                    v-if="!isAuditorRole"
                    color="#2b3990"
                    dark
                    class="mb-2"
                    @click="showAdd()"
                >
                    <v-icon left>add</v-icon>
                    Add Fire Drill
                </v-btn>
              </v-toolbar>
              <v-text-field
                v-model="search"
                clearable
                flat
                solo-inverted
                hide-details
                prepend-inner-icon="search"
                label="search"
                class="mobile ml-5 mr-5 mb-3 mt-3"
              ></v-text-field>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="viewFireDrill(item)">
                mdi-eye
              </v-icon>
              <v-icon v-if="!isAuditorRole" small @click="deleteFireDrill(item)"> mdi-delete </v-icon>
            </template>
            <template v-slot:no-data>
              <v-btn
                color="#2b3990"
                class="white--text"
                @click="getFireDrills()"
                >Reset</v-btn
              >
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <Foot class="hideOnPrint"/>
    <report-table
        :reportHeaderText="reportHeaderText"
        :tableHeaders="reportTableHeader"
        :tableData="reportData"
    />
  </div>
</template>

<script>
import axios from "axios";
import Foot from "@/components/Footer";
import ClientNav from "@/components/ClientNav.vue";
import ClientSide from "@/components/ClientSide.vue";
import moment from "moment";
import renameFileHelper from "@/mixins/renameFileHelper";
import { ROLES } from "@/enums/RolesEnum";
import ReportTable from '@/components/Report/ReportTable.vue';

const url = require("../../client_config/config").url;

export default {
  mixins: [renameFileHelper],
  components: {
    Foot,
    ClientNav,
    ClientSide,
    ReportTable
  },
  data: function () {
    return {
      headers: [
        {
          text: "Drill Date",
          align: "start",
          sortable: false,
          value: "Date",
        },
        { text: "Staff Signature", value: "StaffSignature" },
        { text: "Drill Start Time", value: "StartTime" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      msg: false,
      signed: false,
      search: "",
      text: "",
      fireDrills: [],
      tempData: [],
      codes: [],
      clients: [],
      newClients: [],
      clientID: this.$route.params.clientID,
      role: localStorage.getItem("userRole"),
      display: false,
      nav: true,
      newStaffSignature: "",
      staff: localStorage.getItem("Name"),
      titleForm: "New Fire Drill",
      fireDrillID: "",
      drillDate: moment(new Date()).format("YYYY-MM-DD"),
      evacuated: "",
      evacuatedExplain: "",
      location: "",
      locationExplain: "",
      closedDoors: "",
      closedDoorsExplain: "",
      obstacles: "",
      obstaclesExplain: "",
      headCount: "",
      headCountExplain: "",
      allParticipation: "",
      allParticipationExplain: "",
      startTime: "",
      duration: "",
      numberOfPeople: "",
      taggedCurrent: "",
      taggedCurrentExplain: "",
      detectorsWorking: "",
      detectorsWorkingExplain: "",
      eachLevel: "",
      eachLevelExplain: "",
      carbonMonoxide: "",
      carbonMonoxideExplain: "",
      carbonEachLevel: "",
      carbonEachLevelExplain: "",
      comments: "",
      newDocument: [],
      uploadFile: "",
      fireDrillForm: "",
      editedIndex: -1,
      isLoading: false,
      times: this.getDurations(),
      userState: this.$store.state.users.user.State,
      removedDocuments:[],
      documents: []
    };
  },

  computed: {
    clientName() {
      // `this` points to the component instance
      return this.$store.state.clients.client.Name;
    },
    reportHeaderText() {
        return 'Client Fire Drills';
    },
    reportData() {
        return this.fireDrills
    },
    reportTableHeader() {
        return this.headers.slice(0, this.headers.length-1);
    },
    isAuditorRole() {
        return localStorage.getItem("userRole") === 'Auditor'
    }
  },

  watch: {
    '$route'() {
      this.getFireDrills();
    }
  },

  created() {
    this.getFireDrills();
    this.checkRole();
    this.getClients();
  },

  mounted() {
    this.getFireDrills();
  },
  activated() {
    this.getFireDrills();
  },

  methods: {
    initialize() {
      this.fireDrills = [];
    },

    getDurations() {
      let times = [];
      for (let minutes = 1; minutes <= 10; minutes++) {
        for (let seconds = 0; seconds < 60; seconds += 30) {
          if (minutes === 10 && seconds === 30) {
            continue;
          }
          const time = `${minutes.toString().padStart(2, "0")}:${seconds
            .toString()
            .padStart(2, "0")}`;
          times.push(time);
        }
      }
      return times;
    },

    viewFireDrill(item) {
        this.$router.push({
            path: `/fireDrill/${this.clientID}/update/${item._id}`,
            query: { updateFireDrill: true }
        })
    },

    showAdd() {
      this.$router.push({
          path: `/fireDrill/${this.clientID}/new`,
          query: { createFireDrill: true}
      })
    },

    deleteFireDrill(item) {
      const id = item._id;
      confirm("Are you sure you want to delete this fire drill?") &&
        this.fireDrillDelete(id);
    },

    fireDrillDelete(id) {
      axios.delete(`${url}/fireDrill/${id}`).then((response) => {
        this.getFireDrills();
        if (response.status === 400) {
          response.json().then(function (data) {
            return data.msg;
          });
        }
        this.msg = true;
        this.text = "The fire drill has been deleted successfully.";
      });
    },

    getFireDrills: function () {
      if (this.isLoading === true ) return;

      this.isLoading = true;
      axios
        .get(`${url}/fireDrill/`,
        {
          params: {
            clientID: this.clientID
          },
        })
        .then((res) => {
          this.fireDrills = res.data.docs;
        })
        .finally(() => (this.isLoading = false));
    },

    checkRole() {
      if (
        this.role === "SuperAdministrator" ||
        this.role === "Administration" ||
        this.role === "Program Manager" ||
        this.role === "House Manager" ||
        this.role === "Assistant Manager" ||
        this.role === "Shift Lead" ||
        this.role === "Program Coordinator" ||
        this.role === "Client Services Manager"
      ) {
        this.display = true;
        this.nav = false;
      }
    },

    getClients() {
      let client_url = `${url}/clients`;

      if (this.$store.state.users.userRole !== ROLES.SUPER_ADMINISTRATOR) {
        client_url += `/state/${this.userState}`;
      }
      axios.get(client_url).then((res) => {
        this.clients = res.data.clients;
      });
    },

    printTable() {
        document.getElementById('printTable').style.display = "block";
        window.print()
        document.getElementById('printTable').style.display = "none";
    }
  },
};
</script>
<style>
#printTable{
    display: none;
}

@media print {
    #printTable {
      display: block;
      border: none;
      width: 1200px;
      padding-right: 300px;
      margin-left: -200px;
    }
  
    .hideOnPrint {
      display: none;
      border: none;
    }
  
    nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
      display: none;
      border: none;
  
    }
  
    @page { margin: 0; }
    body { margin: 1.6cm; }
}
</style>
